import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@isophi/core-legacy';
import { MenuSectionKey } from '@isophi/core-ui';
import { TranslocoService } from '@jsverse/transloco';

import { RouterLinkFactory } from '../../../../core/router/router-link.factory';

type InfoBannerType = 'demo' | 'trial' | 'trial-expired' | 'license-expiring' | 'license-expired';

@Component({
  selector: 'app-info-banner',
  templateUrl: './info-banner.component.html',
  styleUrls: ['./info-banner.component.scss'],
  standalone: false,
})
export class InfoBannerComponent {
  private readonly translocoService = inject(TranslocoService);
  protected readonly authService = inject(AuthService);
  private readonly linkFactory = inject(RouterLinkFactory);
  private readonly router = inject(Router);

  @Input() type: InfoBannerType = 'trial';
  @Input() daysLeft?: number;
  @Input() set section(value: MenuSectionKey | null) {
    switch (value) {
      case MenuSectionKey.MANAGEMENT:
        this.sectionLabel = this.translocoService.translate('section/management');
        break;
      case MenuSectionKey.CHILD_PORTFOLIO:
        this.sectionLabel = this.translocoService.translate('section/childPortfolio');
        break;
      case MenuSectionKey.PAP:
        this.sectionLabel = this.translocoService.translate('section/pap');
        break;
      default:
        this.sectionLabel = '';
    }
  }

  protected sectionLabel = '';

  get canRenew(): boolean {
    return !!(this.authService.loggedUser?.teacher?.isDirector() || this.authService.loggedUser?.teacher?.isManager());
  }

  handleRedirectToPriceList(): void {
    this.router.navigate(this.linkFactory.priceList());
  }
}
